var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitedStates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:54007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.418C24.8366 32.418 32 25.2545 32 16.418C32 7.58141 24.8366 0.417969 16 0.417969C7.16344 0.417969 0 7.58141 0 16.418C0 25.2545 7.16344 32.418 16 32.418Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3042 16.4172H31.9998C31.9998 14.9731 31.8073 13.5741 31.4486 12.2433H15.3042V16.4172Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3042 8.06984H29.6514C28.672 6.47159 27.4197 5.0589 25.9596 3.8959H15.3042V8.06984Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 32.4174C19.7649 32.4174 23.2259 31.1159 25.959 28.9391H6.03955C8.77268 31.1159 12.2337 32.4174 15.9993 32.4174Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34797 24.7656H29.6512C30.4375 23.4825 31.0473 22.08 31.4484 20.5916H0.550781C0.951844 22.08 1.56166 23.4825 2.34797 24.7656V24.7656Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4115 2.91659H8.86956L7.51331 3.90191L8.03137 5.49622L6.67519 4.51091L5.319 5.49622L5.7665 4.11891C4.57237 5.11359 3.52575 6.27897 2.66325 7.57747H3.13044L2.26712 8.20466C2.13262 8.42903 2.00362 8.65697 1.88 8.88828L2.29225 10.1571L1.52313 9.59828C1.33194 10.0033 1.15706 10.4175 0.999875 10.8403L1.45406 12.2383H3.13044L1.77419 13.2237L2.29225 14.818L0.936063 13.8327L0.123687 14.4229C0.042375 15.0765 0 15.7423 0 16.418H16C16 7.58147 16 6.53972 16 0.417969C12.8393 0.417969 9.89281 1.33484 7.4115 2.91659V2.91659ZM8.03137 14.818L6.67519 13.8327L5.319 14.818L5.83706 13.2237L4.48081 12.2383H6.15719L6.67519 10.644L7.19319 12.2383H8.86956L7.51331 13.2237L8.03137 14.818ZM7.51331 8.56278L8.03137 10.1571L6.67519 9.17178L5.319 10.1571L5.83706 8.56278L4.48081 7.57747H6.15719L6.67519 5.98316L7.19319 7.57747H8.86956L7.51331 8.56278ZM13.7705 14.818L12.4143 13.8327L11.0581 14.818L11.5762 13.2237L10.2199 12.2383H11.8963L12.4143 10.644L12.9323 12.2383H14.6087L13.2524 13.2237L13.7705 14.818ZM13.2524 8.56278L13.7705 10.1571L12.4143 9.17178L11.0581 10.1571L11.5762 8.56278L10.2199 7.57747H11.8963L12.4143 5.98316L12.9323 7.57747H14.6087L13.2524 8.56278ZM13.2524 3.90191L13.7705 5.49622L12.4143 4.51091L11.0581 5.49622L11.5762 3.90191L10.2199 2.91659H11.8963L12.4143 1.32228L12.9323 2.91659H14.6087L13.2524 3.90191Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:54007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.417969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedStates);
export default __webpack_public_path__ + "static/media/united-states.cb19793f.svg";
export { ForwardRef as ReactComponent };